import { render, staticRenderFns } from "./GradReqsCheck.vue?vue&type=template&id=447129c8&scoped=true&lang=pug&"
import script from "./GradReqsCheck.vue?vue&type=script&lang=js&"
export * from "./GradReqsCheck.vue?vue&type=script&lang=js&"
import style0 from "./GradReqsCheck.vue?vue&type=style&index=0&id=447129c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447129c8",
  null
  
)

export default component.exports